import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { ITrainScheduleResponse } from "../../Orchestrator/Types/Interface/ITrainScheduleResponse";

export async function getTrainSchedule(
  date: string,
  from: string = "",
  to: string = "",
  limit: number = 9999,
  offset: number = 0,
  arrivalFromTime: string = ""
): Promise<IApiResponse<ITrainScheduleResponse>> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getTrainSchedule(date, from, to, limit, offset, arrivalFromTime);

  return await apiRequest<ITrainScheduleResponse>(endpoint, "GET");
}
